import { render, staticRenderFns } from "./TimeLineItemShiftPeriod.vue?vue&type=template&id=53b37abb&"
import script from "./TimeLineItemShiftPeriod.vue?vue&type=script&lang=js&"
export * from "./TimeLineItemShiftPeriod.vue?vue&type=script&lang=js&"
import style0 from "./TimeLineItemShiftPeriod.vue?vue&type=style&index=0&id=53b37abb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports